<template>
  <div class="dw-card">
    <div class="dw-card__head">
      <a-icon v-if="icon" :type="icon" class="dw-card__icon" />
      <span class="dw-card__title">
        {{ title }}
      </span>
      <!-- $scopedSlots, not $slots: the $slots proxy invokes the slot to test it,
           rendering it twice. Callers put v-if on the <template> itself. -->
      <span v-if="$scopedSlots.headerExtra" class="dw-card__head-extra">
        <slot name="headerExtra" />
      </span>
    </div>
    <div class="dw-card__body">
      <!-- Always-visible controls (stay put through loading/empty/error states). -->
      <slot name="toolbar" />
      <div v-if="loading" class="dw-card__state">
        <Spinner />
      </div>
      <div v-else-if="error" class="dw-card__state">
        <a-empty :image="simpleImage" :description="errorMessage" />
      </div>
      <div v-else-if="empty" class="dw-card__state">
        <a-empty :image="simpleImage" :description="empty" />
      </div>
      <slot v-else />
    </div>
  </div>
</template>

<script>
  import { Empty } from 'ant-design-vue';

  export default {
    name: 'WidgetCard',
    props: {
      title: { type: String, required: true },
      icon: { type: String, default: '' },
      loading: { type: Boolean, default: false },
      // Boolean or a message string.
      error: { type: [Boolean, String], default: false },
      // Empty-state message (shown when not loading/errored).
      empty: { type: String, default: '' }
    },
    data() {
      return {
        simpleImage: Empty.PRESENTED_IMAGE_SIMPLE
      };
    },
    computed: {
      errorMessage() {
        return typeof this.error === 'string' ? this.error : 'Could not load data';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .dw-card {
    height: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(21, 27, 34, 0.05);
    overflow: hidden;
    font-family: Roboto, sans-serif;
    color: #323232;

    &__head {
      display: flex;
      align-items: flex-start;
      gap: 7px;
      padding: 12px 16px 5px;
      font-size: 12px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      color: #858688;
    }
    &__icon {
      color: #20a4b8;
      font-size: 14px;
    }
    &__title {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    &__head-extra {
      margin-left: auto;
      display: flex;
      align-items: center;
    }
    &__body {
      flex: 1;
      min-height: 0;
      padding: 4px 16px 12px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: relative;
    }
    &__state {
      height: 100%;
      min-height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
